export const awards = {
  title: "Awards",
  subtitle: "View HR awards for the selected organisation.",
  select_organisation_title: "Select an organisation",
  select_organisation_subtitle: "Choose an organisation to see its awards.",
  no_awards_title: "No awards yet",
  no_awards_subtitle: "There are no awards for this organisation right now.",
  awards_count: "Awards",
  award: "Award",
  create_title: "Create a new award",
  label_name: "Name",
  label_description: "Description",
  label_coin_price: "Coin price",
  label_max_claims: "Max claims",
  label_is_active: "Active",
  btn_create_award: "Create award",
  create_success: "Award created successfully.",
  field_created: "Created",
  field_status: "Status",
  field_price: "Coin price",
  field_max_claims: "Max claims",
  field_claimed_count: "Claimed",
  field_remaining_claims: "Remaining claims",
  status_active: "Active",
  status_inactive: "Inactive",
  delete_confirm_title: "Delete award",
  delete_confirm_message: "Are you sure you want to delete this award?",
  delete_success: "Award deleted successfully.",
  error_delete_award: "Failed to delete award.",
  toggle_success: "Award status updated.",
  error_toggle_award: "Failed to update award status.",
  btn_view_winners: "View winners",
  winners_title: "Award winners",
  winners_subtitle: "See who claimed this award.",
  no_winners_title: "No winners yet",
  no_winners_subtitle: "No claims have been made for this award yet.",
  field_email: "Email",
  field_claimed_at: "Claimed",
  unknown_winner: "Winner",
  select_account_message: "Please select an organisation to load awards.",
  error_loading_awards: "Failed to load awards.",
  error_loading_award_winners: "Failed to load award winners.",
};
